import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import PropTypes from "prop-types";

// Layout Components
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import DashboardLayout from "./layouts/DashboardLayout";
import CVSearch from "./pages/CVSearch";
import CVDetails from "./pages/CVDetails";

import ApplicantEditPage from "./pages/ApplicantEditPage";
// Auth Components
import AuthLayout from "./pages/Authentication/AuthLayout";
import Login from "./components/AuthComponents/Login";
import SignUp from "./components/AuthComponents/Signup";
import ForgotPass from "./components/AuthComponents/ForgotPass";
import Verification from "./components/AuthComponents/Verfication";
import SetPass from "./components/AuthComponents/SetPass";
import Create from "./components/AuthComponents/Create";
import GoogleCallback from "./components/AuthComponents/GoogleCallback";
import AuthCallback from "./components/AuthComponents/AuthCallback";
import ManagerUserProfileMain from "./pages/manager/profile/ManagerUserProfileMain";

// Page Components
import Home from "./pages/Home";
import Chat from "./pages/chat/Chat";
import Fund from "./pages/Fund";
import About from "./pages/About";
import Features from "./pages/Features";
import Resources from "./pages/Resources";
import Contact from "./pages/Contact";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Terms from "./pages/Terms";
import InterviewManagement from "./pages/Interview";
import InterviewGoogle from "./pages/InterviewGoogle";

import SharedApplicants from "./pages/SharedApplicants";
import Partner from "./pages/Partner";
import Cookies from "./pages/Cookies";
import BlogPost from "./pages/BlogPost";
import Pricing from "./pages/Pricing";
import Dashboard from "./pages/Dashboard";
import Jobs from "./pages/Jobs";
import ManageJobs from "./pages/ManageJobs";

import CreateJob from "./pages/CreateJob";
import Calendar from "./pages/Calendar";
import HiringPipeline from "./pages/HiringPipeline";
import Calendar2 from "./pages/Calendar2";
import AiAnalysis from "./pages/AiAnalysis";
import ManagerAiAnalysis from "./pages/ManagerAiAnalysis";

// import CondidateChat from "./pages/CondidateChat";
import Profile from "./pages/Profile";
import Settings from "./pages/Settings";
import Support from "./pages/Support";
// import ChatLayout from "./pages/ChatLayout";
import CandidateEmails from "./pages/CandidateEmails";
import CandidateChat from "./pages/CandidateChat";
import Notfication from "./pages/Notfication";
import NotificationDetail from "./pages/NotificationDetail";
import JobDescription from "./pages/JobDescription";
import JobDetails from "./pages/JobDetails";

import SalaryJob from "./pages/SalaryJob";
import HiringJob from "./pages/HiringJob";
import Reports from "./pages/Reports";
import Candidates from "./pages/Candidates";
import Users from "./pages/Users";
import UserProfile from "./pages/UserProfile";
import UserPermissions from "./pages/UserPermissions";
import Recruiters from "./pages/Recruiters";
import ManagerDashboard from "./pages/manager/ManagerDashboard";
import LimitReachedPage from "./pages/LimitReachedPage"
import EditJob from "./pages/EditJob";
import Applicants from "./pages/Applicants";
import Applications from "./pages/Applications";
import ApplicantDetails from "./pages/ApplicantDetails";
import CreateOffer from "./pages/OfferCreate";
import CreateInterview from "./pages/CreateInterview";

import OfferDetails from "./pages/OfferDetails";
import ApiKeyPage from "./pages/ExternalAPIGuide";

import ClientOffers from "./pages/ClientOffersList";
import EditOffers from "./pages/EditOffers";
import SimpleOfferCreate from "./pages/SimpleOfferCreate";
import JobApplicants from "./pages/JobApplicants";

import UserOffers from "./pages/UserOffersList";
import MyApplicationDetails from "./pages/MyApplicationDetails";

import EmployeeManager from "./pages/EmployeeManager";

import { CandidateProfile } from "./pages/CandidateProfile";
// candidate routes
import CandidateDashboardLayout from "./layouts/CandidateDashboardLayout";
import CandidateDashboard from "./components/candidate/CandidateDashboard";
import CandidateJobs from "./components/candidate/CandidateJobs";
import CandidateJobsDetails from "./components/candidate/CandidateJobsDetails";
import JobApplicationPage from "./components/candidate/JobApply";
import CreateCandidate from "./pages/CreateCandidate";
import CandidateDetails from "./pages/CandidateDetails";

import CandidateAppliedJobs from "./components/candidate/CandidateAppliedJobs";
import CandidateAppliedDetails from "./components/candidate/CandidateAppliedDetails";
import CandidateEditProfileMain from "./components/candidate/profile/CandidateEditProfileMain";
import CompanyProfilesPage from './pages/CompanyProfilesPage';
import CompaniesList from './pages/CompaniesList';
import CandidateUserProfile from "./pages/profile/CandidateUserProfile";
import CompanyProfile from "./components/candidate/company/CompanyProfile";
import CreateClient from "./pages/CreateClient";
import ClientsOverview from "./pages/ClientsOverview";
import ClientDetail from "./pages/ClientDetail";
import PerformanceDashboard from "./pages/PerformanceDashboard";
import RecruiterClientDashboard from "./pages/RecruiterClientDashboard";
import SmartAlertsNudges from "./pages/SmartAlertsNudges";
import CandidateToClientSubmission from "./pages/CandidateToClientSubmission";

import ProfileSettings from "./pages/ProfileSettings";

// Client Auth Components
/* import {
  ClientSignupStep1,
  ClientSignupStep2,
  ClientVerifyEmail,
  ClientAccountReady,
  ClientLogin,
  ClientForgotPassword,
  ClientVerifyResetCode,
  ClientSetNewPassword,
} from "./pages/client/auth";

// Client Pages
import ClientDashboard from "./pages/client/ClientDashboard";
import ShortlistedCandidates from "./pages/client/ShortlistedCandidates";
import OfferTracking from "./pages/client/OfferTracking";
import RoleManagement from "./pages/client/RoleManagement"; */

import { 
  AppliedPage, 
  ShortlistedPage, 
  InterviewScheduledPage, 
  OfferSentPage, 
  HiredPage 
} from './pages/ApplicantStatuses';

// Protected routes that should not show navbar and footer
const PROTECTED_ROUTES = [
  "/auth",
  "/dashboard",
  "/jobs",
  "/clients",
  "/clients/",
  "/clients_overview",
  "/create_client",
  "/performance",
  "/recruiter-dashboard",
  "/edit_job",
  "/create_jobs",
  "/job_description",
  "/salary_job",
  "/hiring_job",
  "/HiringPipeline",
  "/calendar2", 
   "/offer_list", 
   "/job_applicants" ,
   "/edit_offer",
   "/recruitment_manager/dashboard",
   "/recruitment_manager/candidates",
   "/recruitment_manager/recruiters",
   "/recruitment_manager/jobs",
   "/recruitment_manager/users",
   "/recruitment_manager/report",
   "/recruitment_manager/ai_analysis",
   "/recruitment_manager/calendar",
   "/recruitment_manager/chat",
   "/user_offer_list",
   "/candidate/applications",
   "/candidate/company-profiles",
   "/candidate/company-profile/",
   "/my_profile",
   "/interviews",              
  "/ai_analysis",
  "/chat",
  "/candidate_emails",
  "/candidate_chat",
  "/profile",
  "/account-settings",
  "/candidate_profile",
  "/calendar",
  "/settings",
  "/support",
  "/notfications",
  "/candidate/dashboard",
  "/candidate/jobs",
  "/candidate/job-details",
  "/candidate/jobs/appliedjobs",
  "/candidate/jobs/applied-details",
  "/candidate/userprofile",
  "/candidate/editprofile",
  "/candidate/companyprofile",
  "/candidate/chat",
  "/candidate/calendar",
  "/job_details/",
  "/candidates",
  "/notifications",
  "/cvsearch",
  "/cv-details",
  "/applicants",
  "/offer",
'/candidate/job-apply',
'/candidate/my_application',
'/applicant_details/',
'/CreateCandidate',
'/smart-alerts',
'/submission',
'/client',
"/external_guide",
"/shared_candidates"

];

// Create a layout that conditionally renders Navbar and Footer
const Layout = ({ children }) => {
  const location = useLocation();
  const hideNavbarFooter = PROTECTED_ROUTES.some((route) =>
    location.pathname.startsWith(route)
  );

  return (
    <>
      {!hideNavbarFooter && <Navbar />}
      {children}
      {!hideNavbarFooter && <Footer />}
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

const AppRoutes = () => {
  return (
    <Router>
      <ScrollToTop />
      <Layout>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/features" element={<Features />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacypolicy" element={<PrivacyPolicy />} />

          <Route path="/terms" element={<Terms />} />
          <Route path="/cookies" element={<Cookies />} />
          <Route path="/partner" element={<Partner />} />
          <Route path="/blog/:id" element={<BlogPost />} />
          <Route path="/fund" element={<Fund />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/limit-reached" element={<LimitReachedPage />} />

          {/* Auth Routes */}
          <Route path="/auth/*" element={<AuthLayout />}>
            <Route path="login/:type" element={<Login />} />
            <Route path="signup/:type" element={<SignUp />} />
            <Route path="signup/:type/:job_id" element={<SignUp />} />
            <Route path="forgot-password/:type" element={<ForgotPass />} />
            <Route path="verify/:id" element={<Verification />} />
            <Route path="set-password/:type" element={<SetPass />} />
            <Route path="create/:type" element={<Create />} />
            <Route path="google/callback" element={<GoogleCallback />} />
            <Route path="callback" element={<AuthCallback />} />
          </Route>

          {/* Client Auth Routes */}
{/*           <Route path="/client/auth/signup/step1" element={<ClientSignupStep1 />} />
          <Route path="/client/auth/signup/step2" element={<ClientSignupStep2 />} />
          <Route path="/client/auth/signup/verify" element={<ClientVerifyEmail />} />
          <Route path="/client/auth/account-ready" element={<ClientAccountReady />} />
          <Route path="/client/auth/login" element={<ClientLogin />} />
          <Route path="/client/auth/forgot-password" element={<ClientForgotPassword />} />
          <Route path="/client/auth/verify-reset" element={<ClientVerifyResetCode />} />
          <Route path="/client/auth/set-new-password" element={<ClientSetNewPassword />} />
 */}
          {/* Protected Routes */}
          <Route element={<DashboardLayout />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/jobs" element={<Jobs />} />
            <Route path="/clients/:id" element={<ClientDetail />} />
            <Route path="/clients_overview" element={<ClientsOverview />} />
            <Route path="/create_client" element={<CreateClient />} />
            <Route path="/performance" element={<PerformanceDashboard />} />
            <Route path="/recruiter-dashboard" element={<RecruiterClientDashboard />} />
            <Route path="/smart-alerts" element={<SmartAlertsNudges />} />
            <Route path="/edit_job/:id" element={<EditJob />} />
            <Route path="/create_jobs" element={<CreateJob />} />
            <Route path="/job_description" element={<JobDescription />} />
                      <Route path="/external_guide" element={<ApiKeyPage />} />

            <Route path="/salary_job" element={<SalaryJob />} />
            <Route path="/hiring_job" element={<HiringJob />} />
            <Route path="/candidate_profile" element={<CandidateProfile />} />
            <Route
              path="/jobs/applicants/:id"
              element={<JobApplicationPage />}
            />
            <Route path="/HiringPipeline" element={<HiringPipeline />} />
            <Route path="/CreateCandidate" element={<CreateCandidate />} />
            <Route path="/CandidateDetails" element={<CandidateDetails />} />

            <Route path="/calendar" element={<Calendar />} />
            <Route path="/calendar2" element={<Calendar2 />} />
            <Route path="/ai_analysis" element={<AiAnalysis />} />
            <Route path="/chat" element={<Chat />} />
            <Route path="/candidate_chat" element={<CandidateChat />} />
            <Route path="/candidate_emails" element={<CandidateEmails />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/account-settings" element={<Profile />} />
            <Route path="/manager/account-settings" element={<ManagerUserProfileMain />} />
            <Route path="/settings" element={<Profile />} />
            <Route path="/support" element={<Support />} />
            <Route path="/notifications" element={<Notfication />} />
            <Route path="/notifications/:id" element={<NotificationDetail />} />
          </Route>

          {/* candidate routes */}
          <Route element={<CandidateDashboardLayout />}>
            <Route
              path="/candidate/dashboard"
              element={<CandidateDashboard />}
            />
            <Route path="/candidate/jobs" element={<CandidateJobs />} />
            <Route
              path="/candidate/job-details/:id"
              element={<CandidateJobsDetails />}
            />
            <Route
              path="/candidate/job-apply/:id"
              element={<JobApplicationPage />}
            />
            <Route
              path="/applicants/:jobId"
              element={<Applicants />}
            />
           <Route
              path="/applicant_details/:app_id"
              element={<ApplicantDetails />}
            />
            <Route
              path="/submission/:applicant_id"
              element={<CandidateToClientSubmission />}
            />
            <Route
              path="/interviews"
              element={<InterviewManagement />}
            />
         <Route
              path="/interview_google"
              element={<InterviewGoogle />}
            />
            <Route
              path="/candidate/jobs/appliedjobs"
              element={<CandidateAppliedJobs />}
            />
            <Route
              path="/candidate/applications"
              element={<Applications />}
            />
                                <Route path="/shared_candidates" element={<SharedApplicants />} />

            <Route
              path="/candidate/my_application/:app_id"
              element={<MyApplicationDetails />}
            />
                   <Route
              path="/cv-details/:recordId"
              element={<CVDetails />}
            />
           
          <Route
              path="/cvsearch"
              element={<CVSearch />}
            />
            <Route
              path="/candidate/jobs/applied-details/:id"
              element={<CandidateAppliedDetails />}
            />
            <Route
              path="/candidate/userprofile"
              element={<CandidateUserProfile />}
            />
            <Route
              path="/candidate/editprofile/:applicantId"
              element={<ApplicantEditPage />}
            />
            <Route
              path="/candidate/company-profiles"
              element={<CompaniesList />}
            />
            <Route
              path="/candidate/company-profile/:id"
              element={<CompanyProfile />}
            />

     <Route path="/applicants/:jobId/applied" element={<AppliedPage />} />
        <Route path="/applicants/:jobId/shortlisted" element={<ShortlistedPage />} />
        <Route path="/applicants/:jobId/interview_scheduled" element={<InterviewScheduledPage />} />
        <Route path="/applicants/:jobId/offer_sent" element={<OfferSentPage />} />
        <Route path="/applicants/:jobId/hired" element={<HiredPage />} />

        <Route path="/create_offer/:jobId/:applicantId" element={<CreateOffer/>} />
        <Route path="/create_interview/:jobId/:applicantId" element={<CreateInterview/>} />
        <Route path="/offer_list/:jobId" element={<ClientOffers />} />
        <Route path="/job_details/:id" element={<JobDetails />} />

        <Route path="/edit_offer/:offerId" element={<EditOffers />} />

        <Route path="/user_offer_list" element={<UserOffers />} />
        <Route path="/offer_list" element={<ClientOffers />} />   
        <Route path="/employee_manager" element={<EmployeeManager />} />        
     
        <Route path="/offer_details/:id" element={<OfferDetails />} />
        <Route path="/job_applicants/:jobId" element={<JobApplicants />} />
        <Route path="/offer/create/:applicantId" element={<SimpleOfferCreate />} />
        <Route path="/offer/create" element={<SimpleOfferCreate />} />

        
            <Route path="/candidate/chat" element={<CandidateChat />} />
            <Route
              path="/candidate/jobs/appliedjobs"
              element={<CandidateAppliedJobs />}
            />
            <Route
              path="/candidate/jobs/applied-details/:id"
              element={<CandidateAppliedDetails />}
            />
            <Route path="/candidate/calendar" element={<Calendar />} />
            <Route path="/my_profile" element={<CandidateUserProfile />} />

            <Route path="/recruitment_manager/candidates" element={<Candidates />} />
              <Route path="/recruitment_manager/dashboard" element={<ManagerDashboard />} />
              <Route path="/recruitment_manager/recruiters" element={<Recruiters />} />
              <Route path="/recruitment_manager/jobs" element={<ManageJobs />} />
              <Route path="/recruitment_manager/chat" element={<Chat />} />

            <Route path="/recruitment_manager/users" element={<Users />} />
            <Route path="/user/:id" element={<UserProfile />} />
            <Route path="/user/:id/edit" element={<UserProfile />} />
            <Route path="/user/:id/permissions" element={<UserPermissions />} />
            <Route path="/recruitment_manager/report" element={<Reports />} />
            <Route path="/recruitment_manager/ai_analysis" element={<ManagerAiAnalysis />} />
            <Route path="/recruitment_manager/calendar" element={<Calendar />} />
            <Route path="/candidates" element={<Candidates />} />

            {/* Client Dashboard Routes */}
         {/*    <Route path="/client/dashboard" element={<ClientDashboard />} />
            <Route path="/client/roles" element={<RoleManagement />} />
            <Route path="/client/shortlisted-candidates" element={<ShortlistedCandidates />} />
            <Route path="/client/offer-tracking" element={<OfferTracking />} /> */}

          </Route>
        </Routes>
      </Layout>
    </Router>
  );
};

export default AppRoutes;

